export { default } from './src/Tooltip';
export { createTooltip } from './src/Tooltip';
export type { TooltipProps } from './src/Tooltip';
